import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";

@Injectable()
export class ProjectAppSelectionsService extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('project-app-selections', service);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/project-partnumbers/services/project-app-selections.service.ts